import { Component, OnInit, Input, HostListener, ViewChild, Output, EventEmitter } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { RxTransferService, AlertService, TransmissionService } from "src/app/services";
import { CollectionView } from "@grapecity/wijmo";
import { PatAuditLog, RxModel, RxPay } from "src/app/models";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MsgConfig } from "src/app/app.messages";
import { FormBuilder, FormGroup } from "@angular/forms";
import * as moment from "moment";
import { NewAuditUtils, WijimoUtil } from "src/app/utils";
import * as wjcGrid from "@grapecity/wijmo.grid"
import { takeUntil } from "rxjs/operators";
import { StorageService } from "src/app/services/storage.service";

@Component({
    selector: "app-pay-records",
    templateUrl: "./pay-records.component.html",
    standalone: false
})
export class PayRecordsComponent implements OnInit {
    subscriptions = new Subscription();
    prescRefillID: any;
    rxTransmissionWJ: any;
    modalRefSM: any;
    payRecrds: any;
    originalPayRecords: any;

    @Input() rxInfo: RxModel;
    editPayFG: FormGroup;
    benefitInfoWJ: CollectionView;
    benefitFG: FormGroup;
    modalRefBF: any;
    modalRefRJ: any;
    rejCodeWJ: any;
    rejectList: any;
    tempRxNumber: any;
    duplicateList: boolean;
    isDataExists : boolean = false;
    data : any;
    M3PInsu = [];
    unsubscribe$ : Subject<void> = new Subject();
    rxPaywjHeaders: any;
    
    @Input() set PayRecrds(pr) {
        this.payRecrds = pr;
        if (pr && pr["length"] > 0) {
            this.generateLogsWJ(pr);
        }
    }

    @Output()
    ClosePayRecords = new EventEmitter<any>();

    @ViewChild("PayRecordDeleteWarning", { static: true })
    PayRecordDeleteWarning: any;

    @ViewChild("PayRecordEdit", { static: true })
    PayRecordEdit: any;

    @ViewChild("BenefitInfoEdit", { static: true })
    BenefitInfoEdit: any;

    @ViewChild("RejectcodesEdit", {static: true})
    RejectcodesEdit: any;

    @HostListener("window:keydown", ["$event"])
    keyEventAlt(event: KeyboardEvent) {
        if (event.which === 27) { // esc
            event.preventDefault();
            this.closeModalSM();
        }
        if (event.altKey && this._modalService.hasOpenModals() && (!this.modalRefRJ) && (!this.modalRefSM)) {
            if (event.which === 67) { // c
                event.preventDefault();
                this.previousPage();
            }
        }
    }

    constructor(private _fb: FormBuilder,
        private _rxTrnsfrSvc: RxTransferService, private _transmsnServ: TransmissionService, private _wijimoUtils: WijimoUtil,
        private _modalService: NgbModal, private _alertSvc: AlertService, private _auditUtils: NewAuditUtils, public _storageService: StorageService) { }

    ngOnInit() {
        let ins = this.rxInfo?.Patient?.insurance as any[];
        ins?.filter((item) => {
            if (item?.parentInsuId)
                this.M3PInsu?.push(item?.InsurerCode?.trim()?.toUpperCase())
        })
        this._storageService.setSessionStorage("fromPaGrid", true);
        this.patchDefaultValHeaders();
        this._wijimoUtils.wjSavedData$.pipe(takeUntil(this.unsubscribe$)).subscribe(w => {
            if (w && w["WijmoKey"] && w["WijmoKey"] === "reverseClaim") {
                this.patchDefaultValHeaders();
            }
        });
        
    }
   
    async patchDefaultValHeaders() {
        const storedWJ = await this._wijimoUtils.getWJSavedData("reverseClaim");
        this.rxPaywjHeaders = this._wijimoUtils.patchDefHeader("reverseClaim", storedWJ);
    }

    generateLogsWJ(rxLogs) {
        this.rxTransmissionWJ = new CollectionView(rxLogs?.map((logs: any, i) => {
        const k = {};
        k["RowId"] = i;
        k["Rx#"] = logs?.PrescNum ? logs?.PrescNum : '';
        k["Ref#"] = k["RefillNum"] = logs.RefillNum;
        k["Fill#"] = k["FillNo"] = logs.FillNo;
        k["Rec Type"] = k["RecType"] = logs?.RecType ? logs?.RecType : '';
        k["Cov"] = logs?.CoverageCD ? logs?.CoverageCD : '0';
        k["Ins.Code"] = k["Ins_Code"] = logs?.Ins_Code ? logs?.Ins_Code : '';
        k["Date"] = k["DatePaid"] = logs?.DatePaid ? moment.utc(logs?.DatePaid).local().format(MsgConfig.DATE_FORMAT) : '';
        k["OTHPYRPDQ"] = k["OthPYRPDQ"] = logs?.OthPYRPDQ ? logs?.OthPYRPDQ : '';
        k["Ingr.Cost Paid"] = logs?.ICostPaid ? '$'+(logs?.ICostPaid).toFixed(2) : '$0.00';
        k["ICostPaid"] = logs?.ICostPaid;
        k["Fee Paid"] = logs?.DFEEPaid ? '$'+(logs?.DFEEPaid).toFixed(2) : '$0.00';
        k["DFEEPaid"] = logs?.DFEEPaid;
        k["Pat Pay"] = logs?.PTPayment ? '$'+(logs?.PTPayment).toFixed(2) : '$0.00';
        k["PTPayment"] = logs?.PTPayment;
        k["FSTAXAMT"] = k["FSTaxAmt"] = logs?.FSTaxAmt ? '$'+(logs?.FSTaxAmt).toFixed(2) : '$0.00';
        k["PSTAXAMT"] = k["PSTaxAmt"] = logs?.PSTaxAmt ? '$'+(logs?.PSTaxAmt).toFixed(2) : '$0.00';
        k["PSTAXRATE"] = logs?.PSTaxRate ? '$'+(logs?.PSTaxRate).toFixed(2) : '$0.00';
        k["PSTaxRate"] = logs?.PSTaxRate;
        k["INCAMTPAID"] = logs?.INCAMTPaid ? '$'+(logs?.INCAMTPaid).toFixed(2) : '$0.00';
        k["INCAMTPaid"] = logs?.INCAMTPaid;
        k["PSFEEPAID"] = logs?.PSFEEPaid ? '$'+(logs?.PSFEEPaid).toFixed(2) : '$0.00';
        k["PSFEEPaid"] = logs?.PSFEEPaid;
        k["OTHERAMTPAID"] = logs?.OthAmtPaid ? '$'+(logs?.OthAmtPaid).toFixed(2) : '$0.00';
        k["OthAmtPaid"] = logs?.OthAmtPaid;
        k["OthPayRecog."] = logs?.OthPayRecg ? '$'+(logs?.OthPayRecg).toFixed(2) : '$0.00';
        k["OthPayRecg"] = logs?.OthPayRecg;
        k["NetPaid"] = logs?.TotAmtPaid ? '$'+(logs?.TotAmtPaid).toFixed(2) : '$0.00';
        k["TotAmtPaid"] = logs?.TotAmtPaid;
        k["OTHPAYQ1"] = k["OthPayQ1"] = logs?.OthPayQ1 ? logs?.OthPayQ1 : '';
        k["OTHPAYAMT1"] = logs?.OthPayAmt1 ? '$'+(logs?.OthPayAmt1).toFixed(2) : '$0.00';
        k["OthPayAmt1"] = logs?.OthPayAmt1;
        k["OTHPAYQ2"] = k["OthPayQ2"] = logs?.OthPayQ2 ? logs?.OthPayQ2 : '';
        k["OTHPAYAMT2"] = logs?.OthPayAmt2 ? '$'+(logs?.OthPayAmt2).toFixed(2) : '$0.00';
        k["OthPayAmt2"] = logs?.OthPayAmt2;
        k["OTHPAYQ3"] = k["OthPayQ3"] = logs?.OthPayQ3 ? logs?.OthPayQ3 : '';
        k["OTHPAYAMT3"] = logs?.OthPayAmt3 ? '$'+(logs?.OthPayAmt3).toFixed(2) : '$0.00';
        k["OthPayAmt3"] = logs?.OthPayAmt3;
        k["TAXEXEMPT"] = k["TaxExempt"] = logs?.TaxExempt ? logs?.TaxExempt : '';
        k["BASISOFREI"] = logs?.BASISOFREI ? logs?.BASISOFREI : '';
        k["BOC_DFEE"] = logs?.BOC_DFEE ? logs?.BOC_DFEE : '';
        k["BOC_COPAY"] = k["BOC_Copay"] = logs?.BOC_Copay ? logs?.BOC_Copay : '';
        k["BOC_FSTAX"] = k["BOC_FSTax"] = logs?.BOC_FSTax ? logs?.BOC_FSTax : '';
        k["BOC_PSTAX"] = k["BOC_PSTax"] = logs?.BOC_PSTax ? logs?.BOC_PSTax : '';
        k["REJCODES"] = k["REJCodes"] = logs?.REJCodes ? logs?.REJCodes : '';
        k["AMT_PREDED"] = logs?.Amt_PERDED ? '$'+(logs?.Amt_PERDED).toFixed(2) : '$0.00';
        k["Amt_PERDED"] = logs?.Amt_PERDED;
        k["AMT_SALETX"] = logs?.Amt_SaleTx ? '$'+(logs?.Amt_SaleTx).toFixed(2) : '$0.00';
        k["Amt_SaleTx"] = logs?.Amt_SaleTx;
        k["AMT_COPINS"] = k["Amt_COPINS"] = logs?.Amt_COPINS ? logs?.Amt_COPINS : '0';
        k["AMT_PRODSL"] = k["Amt_PRODSL"] = logs?.Amt_PRODSL ? logs?.Amt_PRODSL : '0';
        k["AMT_EXCMAX"] = k["Amt_EXCMAX"] = logs?.Amt_EXCMAX ? logs?.Amt_EXCMAX : '0';
        k["INSNETPAID"] = logs?.InsNetPaid ? '$'+(logs?.InsNetPaid).toFixed(2) : '$0.00';
        k["PSTaxBasisPaid"] = k["PSTaxBasisPaid"] = logs?.PSTaxBasisPaid ? logs?.PSTaxBasisPaid : '';
        k["AccumDedAmt"] = logs?.AccumDedAmount ? '$'+(logs?.AccumDedAmount).toFixed(2) : '$0.00';
        k["AccumDedAmount"] = logs?.AccumDedAmount;
        k["RemDedAmt"] = logs?.RemDedAmount ? '$'+(logs?.RemDedAmount).toFixed(2) : '$0.00';
        k["RemDedAmount"] = logs?.RemDedAmount;
        k["RemBenefitAmt"] = logs?.RemBenefitAmount ? '$'+(logs?.RemBenefitAmount).toFixed(2) : '$0.00';
        k["RemBenefitAmount"] = logs?.RemBenefitAmount;
        k["AmtProcFee"] = logs?.AmtProcFee ? '$'+(logs?.AmtProcFee).toFixed(2) : '$0.00';
        k["PatSTaxAmt"] = logs?.PatSTaxAmt ? '$'+(logs?.PatSTaxAmt).toFixed(2) : '$0.00';
        k["AmtCoIns"] = logs?.AmtCoIns ? logs?.AmtCoIns : 0;
        k["BOC_CoIns"] = logs?.BOC_CoIns ? logs?.BOC_CoIns : '';
        k["EstGen"] = k["EstGenSavings"] = logs?.EstGenSavings ? logs?.EstGenSavings : '0';
        k["SpendAccAmtRem"] = logs?.SpendAccAmtRem ? '$'+(logs?.SpendAccAmtRem).toFixed(2) : '$0.00';
        k["HPIanFundAmt"] = logs?.HPlanFundAmt ? '$'+(logs?.HPlanFundAmt).toFixed(2) : '$0.00';
        k["AmtProvNetSel"] = logs?.AmtProvNetSel ? '$'+(logs?.AmtProvNetSel).toFixed(2) : '$0.00';
        k["AmtProdSelBrand"] = logs?.AmtProdSelBrand ? '$'+(logs?.AmtProdSelBrand).toFixed(2) : '$0.00';
        k["AmtProdSelNPForm"] = logs?.AmtProdSelNPForm ? '$'+(logs?.AmtProdSelNPForm).toFixed(2) : '$0.00';
        k["AmtProdSelNPFormB"] = logs?.AmtProdSelNPFormB ? '$'+(logs?.AmtProdSelNPFormB).toFixed(2) : '$0.00';
        k["AmtCovGap"] = logs?.AmtCovGap ? '$'+(logs?.AmtCovGap).toFixed(2) : '$0.00';
        k["IngCostContRAmt"] = logs?.IngCostContRAmt ? '$'+(logs?.IngCostContRAmt).toFixed(2) : '$0.00';
        k["DFeeContRAmt"] = logs?.DFeeContRAmt ? '$'+(logs?.DFeeContRAmt).toFixed(2) : '$0.00';
        k["COBBillSeq"] = logs?.CoverageCD == 0 ? "P" : logs?.CoverageCD == 1 ? "S" : logs?.CoverageCD == 2 ? "T" : "Q";
        k["CoverageCD"] = logs?.CoverageCD;
        k["InsNetPaid"] = logs?.InsNetPaid;
        k["MFP/SDRA"] = logs?.MFPAmt ? '$'+(logs?.MFPAmt).toFixed(2) : '$0.00';
        k["MFPAmt"] = logs?.MFPAmt;
        k["Auth_No"] = logs?.Auth_No;
        k["PrescRefillId"] = logs?.PrescRefillId;
        k["RxId"] = logs?.RxId;
        k["TransClaimLogId"] = logs?.TransClaimLogId;
        k["PrescNum"] = logs?.PrescNum;
        k["Id"] = logs?.Id;
        k["IsDeleted"] = logs?.IsDeleted;
        k["RejectReasons"] = logs?.RejectReasons;
        k["TenantId"] = logs?.TenantId;
        return k;
      }))
    }

    itemFormatter = (panel, r, c, cell) => {
        const row = panel.rows[r];
        if (row.dataItem) {
            cell.style.background = "";
             if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Ins_Code" && this.M3PInsu?.includes(row.dataItem?.Ins_Code?.trim()?.toUpperCase())) {
                cell.style.backgroundColor = "#51a351";
                cell.style.color = "#fff";
            }
            if (panel.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "MFP/SDRA" && row.dataItem?.MFPAmt > 0) {
                cell.style.backgroundColor = "#51a351";
                cell.style.color = "#fff";
            } else {
                cell.style.backgroundColor = "#FFF";
                cell.style.color = "#000";
                cell.style.fontWeight = "normal";
                cell.style.textAlign = "initial";
            }
        }
    }
    previousPage() {
        this.ClosePayRecords.emit("Patient1");
    }

    closeModalSM() {
        if (this.modalRefSM) {
            this.modalRefSM.close();
            this.modalRefSM = null;
        }
    }

    closeBFModal() {
        if (this.modalRefBF) {
            this.modalRefBF.close();
        }
    }

    async deletePayRecord(item: any) {
        if (item.RecType === "R" || item.RecType === "C") {
            const resp = await this._rxTrnsfrSvc.deletePayRecord(item.Id).toPromise();
            if (resp === true) {
                this._alertSvc.success(MsgConfig.DELETE_SUCCESS);
                // const resp2 = await this._transmsnServ.getPayRecord(this.rxInfo.PrescReFill.Id).toPromise();
                // this._transmsnServ._payRecords$.next(resp2);
                await this.getPayRecords();
            }
        } else if (item.RecType === "P") {
            this.modalRefSM = this._modalService.open(this.PayRecordDeleteWarning, {centered: true,
                backdrop: false, windowClass: "large--content"
            });
            setTimeout(() => {
                document.getElementById("payRecordDelete").focus();
            }, 100);
        }
    }

    focusOnCancel(event) {
        if (document.getElementById("cancelButton")) {
            event.preventDefault();
            document.getElementById("cancelButton").focus();
        }
    }

    openEditModal(val) {
        this.editPayFG = this._fb.group(new RxPay());
        this.editPayFG.patchValue(val);
        this.getBatchDetails();
        this.patchEditPay();
        this.modalRefSM = this._modalService.open(this.PayRecordEdit, {size: "lg", windowClass: "md-x-lg", backdrop: false});
    }

    async getBatchDetails() {
      this.data =  await this._transmsnServ.getPayDetails(this.rxInfo.PrescReFill.Id).toPromise();
      this.isDataExists =  this.data && this.data.length ? true : false;
      this.benefitInfoWJ = new CollectionView(this.data);
    }

    openBenfitEdit(val) {
        this.benefitFG = this._fb.group({
            Id: null,
            PrescRefillId: null,
            RxId: null,
            Fillno: null,
            Ins_Code: null,
            FieldName: null,
            FieldValue1: null,
            FieldValue2: null,
            RxNo: null,
            RfNo: null,
        });
        this.benefitFG.patchValue(val);
        this.benefitFG.patchValue({
            RxNo: this.rxInfo.Prescription.PrescNum,
            RfNo: this.rxInfo.PrescReFill.ReFillNum
        });
        this.modalRefBF = this._modalService.open(this.BenefitInfoEdit, {centered: true, backdrop: false});
    }

    async updateBenefit() {
        const resp = await this._transmsnServ.updateBenifitInfo(this.benefitFG.getRawValue()).toPromise();
        if (resp) {
            this._alertSvc.success(MsgConfig.UPDATE_SUCCESS);
            await this.getBatchDetails();
        }
        this.closeBFModal();
    }

    patchEditPay() {
        const cntrlNames = ["ICostPaid", "DFEEPaid", "PTPayment", "FSTaxAmt", "PSTaxAmt", "PSTaxRate",
        "INCAMTPaid", "PSFEEPaid", "OthAMTPaid", "OthPayRecg", "TotAmtPaid", "OthPayAmt1", "OthPayAmt2", "OthPayAmt3",
        "Amt_PERDED", "Amt_COPINS", "Amt_SaleTx", "Amt_PRODSL", "PSTaxBasisPaid", "AccumDedAmount",
         "RemDedAmount", "RemBenefitAmount", "Amt_EXCMAX", "DIRFee", "MFPAmt"];
         cntrlNames.map(cntrl => this.editPayFG.controls[cntrl].patchValue(
            this.editPayFG.value[cntrl] ? (parseFloat(this.editPayFG.value[cntrl])).toFixed(2) : "0.00"
         ));
         const trimCntrlN = ["BOC_PSTax", "BOC_FSTax", "BOC_Copay", "BOC_DFEE", "BASISOFREI"];
         trimCntrlN.map(cntrl => this.editPayFG.controls[cntrl].patchValue(
            this.editPayFG.value[cntrl] ? this.editPayFG.value[cntrl].trim() : null
         ));
         this.editPayFG.controls["DatePaid"].patchValue(moment.utc(this.editPayFG.value["DatePaid"]).local().format("MM/DD/YYYY"));
         this.originalPayRecords = Object.assign({}, this.editPayFG.value);
    }

    setNumberFormat(cntrl) {
        this.editPayFG.controls[cntrl].patchValue(this.editPayFG.value[cntrl] ?
            (parseFloat(this.editPayFG.value[cntrl])).toFixed(2) : "0.00");
    }

    async UpdatePayRecords() {
        const payloadData = { ...this.editPayFG.value };
        for (const key in payloadData) {
            if (typeof payloadData[key] === "string") {
                payloadData[key] = payloadData[key].replace(/\$/g, "").replace(/0.00/g, '0');
            }
        }
        await this._rxTrnsfrSvc.updatePayRecord(payloadData).toPromise();
        this._alertSvc.success(MsgConfig.UPDATE_SUCCESS);
        const payRecordTrasmissionsModel = new PatAuditLog().payRecordTrasmissionsModel;
            this._auditUtils.saveAuditChange(
                this.originalPayRecords,
                this.editPayFG.getRawValue(),
                "PayRecords",
                "Rx",
                this.rxInfo.PrescReFill.Id,
                payRecordTrasmissionsModel
            );
        this.closeModalSM();
        await this.getPayRecords();
    }

    async getPayRecords() {
        const resp = await this._transmsnServ.getPayRecord(this.rxInfo.PrescReFill.Id).toPromise();
        this._transmsnServ.storePayRecords(resp);
        this.payRecrds = resp;
        this.generateLogsWJ(resp);
    }
    setTempRx(rejCode) {
        this.tempRxNumber = rejCode;
    }

    openRejectCodes() {
        this.rejectList = this.editPayFG.controls["REJCodes"].value.split(",");
        this.generateRejCodesWJ(this.rejectList);
        this.modalRefRJ = this._modalService.open(this.RejectcodesEdit, {centered: true, backdrop: false, size: "sm",
        windowClass: "medium-sm-modal-23"});
    }
    generateRejCodesWJ(list) {
        this.rejCodeWJ = new CollectionView(
            list.map((rx, i) => {
                const k = {};
                k["RowId"] = i;
                k["RejectCodes"] = rx;
                return k;
        })
        );
    }
    closeRejectPopup() {
        if (this.modalRefRJ) {
            this.modalRefRJ.close();
            this.modalRefRJ = null;
            this.tempRxNumber = null;
        }
    }
    removeRejectCodeModal(item) {
        this.rejectList = this.rejectList.filter((code: any) => {
            return (code !== item);
        });
        this.editPayFG.controls["REJCodes"].patchValue(this.rejectList.join(","));
    }
    addRejCode() {
        if (this.tempRxNumber) {
            this.rejectList.map((num: any) => {
                if (num === this.tempRxNumber.toUpperCase()) {
                    this.duplicateList = true;
                }
            });
            if (this.duplicateList) {
                this.duplicateList = false;
                this._alertSvc.error("Code already exists in the list.");
            } else {
                this.rejectList.push(this.tempRxNumber.toUpperCase());
                this.editPayFG.controls["REJCodes"].patchValue(this.rejectList.join(","));
                this.duplicateList = false;
            }
            this.tempRxNumber = null;
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        sessionStorage.removeItem("fromPaGrid");
        this._storageService.getWijmoGridDataInSession(this.rxPaywjHeaders,"reverseClaim")
    }
 }
